import { render, staticRenderFns } from "./relocationContract.vue?vue&type=template&id=66b252be&scoped=true"
import script from "./relocationContract.vue?vue&type=script&lang=js"
export * from "./relocationContract.vue?vue&type=script&lang=js"
import style0 from "./relocationContract.vue?vue&type=style&index=0&id=66b252be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b252be",
  null
  
)

export default component.exports